<template>
  <div>
    <div style="display: flex; justify-content: space-between; gap: 20px; margin-bottom: 20px">
      <div style="width: 30%;">
        <p>Выберите дату и время</p>

        <v-datetime-picker
          v-model="dateFrom"
          color="accent"
          label="Выберите дату от"
        />

        <v-datetime-picker
          v-model="dateTo"
          color="accent"
          label="Выберите дату до"
        />
      </div>

      <div style="width: 30%;">
        <v-text-field
          v-model="userId"
          color="accent"
          append-icon="search"
          label="Id пользователя"
          single-line
          hide-details
          type="number"
        />
        <br>

        <v-select
          v-model="currentStatusFilter"
          class="filter"
          :items="dropdownStatusItems"
          color="accent"
          label="Статус"
          item-title="title"
        >
          <template #selection="{ item }">
            {{ item.title }}
          </template>

          <template #item="{ item }">
            {{ item.title }}
          </template>
        </v-select>
      </div>
    </div>

    <paginated-table
      ref="paginatedTable"
      :items="points"
      :pullFunction="getTrustPoints"
      :headers="headers"
      :pagination.sync="pagination"
      :loading="loading"
    >
      <template #items="props">
        <td>{{ props.item.created_at }}</td>
        <td>
          <v-btn
            text
            small
            flat
            :to="{ name: 'user', params: { user: props.item.user.id } }"
            class="user_link"
          >
            {{ props.item.user.id }}
          </v-btn>
        </td>
        <td>{{ props.item.trust_balance }}</td>
        <td>{{ props.item.balance }}</td>
        <td>{{ props.item.difference }}</td>
        <td><div :class="`status status-color-${props.item.status}`" />{{ getStatus(props.item.status) }}</td>
      </template>
    </paginated-table>
  </div>
</template>

<script>
import PaginatedTable from '@/components/PaginatedTable.vue'
import { getTrustPoints } from '../../api/trust'
import VueMixin from '@/components/VueMixin.vue'

export default {
  name: 'TrustPoints',
  components: { PaginatedTable },
  mixins: [VueMixin],
  data () {
    return {
      points: [],
      dateTo: null,
      dateFrom: null,
      loading: false,
      userId: '',
      page: 1,
      pagination: {
        sortBy: 'created_at:desc',
        descending: true
      },
      headers: [
        {
          text: 'Дата создания записи', value: 'created_at', sortable: true
        },
        {
          text: 'ID пользователя', value: 'user.id', sortable: false
        },
        {
          text: 'Расчетный баланс', value: 'trust_balance', sortable: false
        },
        {
          text: 'Баланс', value: 'balance', sortable: false
        },
        {
          text: 'Разница', value: 'difference', sortable: true
        },
        {
          text: 'Статус', value: 'status', sortable: false
        }
      ],
      currentStatusFilter: null,
      dropdownStatusItems: [
        {
          title: 'Все',
          value: null
        },
        {
          title: 'Отказано',
          value: '1'
        },
        {
          title: 'Принято',
          value: '2'
        },
        {
          title: 'В процессе',
          value: '0'
        }
      ]
    }
  },
  watch: {
    dateFrom () {
      this.getTrustPoints(1)
    },
    dateTo () {
      this.getTrustPoints(1)
    },
    currentStatusFilter () {
      this.getTrustPoints(1)
    },
    userId () {
      this.getTrustPoints(1)
      this.$refs.paginatedTable?.resetPagination()
    },
    pagination: {
      handler (newPagination) {
        if (newPagination.sortBy === 'created_at' || newPagination.sortBy === 'difference')
          this.getTrustPoints(1)
      },
      deep: true
    }
  },
  created () {
    this.getTrustPoints(this.page)
  },
  methods: {
    getTrustPoints (page) {
      this.loading = true
      this.page = page

      let sortParam = 'created_at:desc'
      if (this.pagination.sortBy === 'created_at' || this.pagination.sortBy === 'difference') {
        const sortOrder = this.pagination.descending ? 'desc' : 'asc'
        sortParam = `${this.pagination.sortBy}:${sortOrder}`
      }

      getTrustPoints({
        limit: 26,
        offset: (page - 1) * 25,
        sort: sortParam,
        date_from: this.dateFrom ? this.formatDateFilter(this.dateFrom) : undefined,
        date_to: this.dateTo ? this.formatDateFilter(this.dateTo) : undefined,
        user_id: this.userId,
        status: this.currentStatusFilter
      }).then(response => {
        this.points = response.data
        this.loading = false
      })
    },
    getStatus (status) {
      if (status === 1)
        return 'Отказано'
      if (status === 2)
        return 'Принято'
      if (status === 0)
        return 'В процессе'
    }
  }
}
</script>

<style scoped>
.status {
  display: inline-block;
  margin-right: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.user_link {
  text-transform: none;
  padding: 0;
  min-width: auto;
  margin: 0;
}

.status-color-1 {
  background: red;
}

.status-color-2 {
  background: green;
}

.status-color-0 {
  background: yellow;
}
</style>
